function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M11.79,6.37A3.185,3.185,0,1,0,8.61,3.18,3.192,3.192,0,0,0,11.79,6.37Zm0-4.94a1.755,1.755,0,1,1-1.76,1.75A1.754,1.754,0,0,1,11.79,1.43Z",
  transform: "translate(0 0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12.767,9.655H10.813a.665.665,0,1,0,0,1.33h1.954a.665.665,0,0,0,0-1.33Z",
  transform: "translate(0 0)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5.42,11.41a.78.78,0,1,0,.78.78A.781.781,0,0,0,5.42,11.41Z",
  transform: "translate(0 0)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M21.64,10.36a.662.662,0,0,0-.66.67.653.653,0,0,0,.66.66,1.03,1.03,0,1,1,0,2.06,1,1,0,0,1-.84-.44,7.248,7.248,0,0,0-7.17-6.13H8.33A3.309,3.309,0,0,0,5.37,5.34H4.66V8.38a7.251,7.251,0,0,0-2.62,3.08H1a1,1,0,0,0-1,1V16.4a1,1,0,0,0,1,1H2.04a7.31,7.31,0,0,0,1.83,2.48,7.193,7.193,0,0,0,2.64,1.48V23a1,1,0,0,0,1,1H9.56a.994.994,0,0,0,.99-1V21.69h1.19V23a1,1,0,0,0,1,1h2.04a1,1,0,0,0,1-1V21.36a7.27,7.27,0,0,0,5.08-6.21v-.2a2.5,2.5,0,0,0,.78.13,2.36,2.36,0,1,0,0-4.72ZM18.17,18.1a5.857,5.857,0,0,1-3.26,2.02l-.55.13v2.32H13.17V21.26a1,1,0,0,0-1-1H10.12a.994.994,0,0,0-.99,1v1.31H7.94V20.25l-.56-.13a5.818,5.818,0,0,1-4.19-3.68l-.17-.46H1.43V12.89H3.02l.17-.47A5.823,5.823,0,0,1,5.72,9.4l.36-.21V6.91A1.872,1.872,0,0,1,7.17,8.13l.16.59.61-.07a5.807,5.807,0,0,1,.72-.05h4.76a5.979,5.979,0,0,1,6.04,5.55A5.793,5.793,0,0,1,18.17,18.1Z",
  transform: "translate(0 0)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/savings.1d4fee98.svg";
export { SvgComponent as ReactComponent };